module.exports = __webpack_public_path__ + "img/zeppelin-logo.5f1482aa.svg";